import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';

import './desktop-login-style.scss';
import useIsComDomain from '@src/hooks/useIsComDomain';

import BasicModal from '@src/componentsNew/Modals/BasicModal/BasicModal'; // Todo: remove after com
import Button from '@src/componentsNew/Buttons/Button';
import Typography from '@src/componentsNew/Typography/Typography';
import GoogleLoginButton from '@src/componentsNew/Buttons/SocialLoginButton/GoogleLoginButton';
import FacebookLoginButton from '@src/componentsNew/Buttons/SocialLoginButton/FacebookLoginButton';
import VisibilityIcon from '@src/componentsNew/Icons/Icons/VisibilityIcon';
import VisibilityOffIcon from '@src/componentsNew/Icons/Icons/VisibilityOffIcon';

import { tncUrl, passwordResetUrl, accountSignupUrl } from '@src/app/routes';

const DesktopLoginPage = ({ formik, loading, showPassword, onChagneShowPassword }) => {
  const isComDomain = useIsComDomain();

  // Todo: remove after com
  const [showAlertModal, setShowAlertModal] = useState(false);
  const handleAlertModalClose = (e) => {
    e.stopPropagation();
    setShowAlertModal(false);
  };

  return (
    <div id="desktop-login-wrapper">
      <form className="login-form" onSubmit={formik?.handleSubmit}>
        <Typography variant="h6" component="h4" style={{ color: '#212121' }}>
          Log In
        </Typography>

        <div className="login-input-wrapper">
          <TextField
            type="email"
            size="medium"
            className="email-input"
            label="Email"
            name="email"
            value={formik?.values?.email}
            onChange={formik?.handleChange}
            error={!!formik.errors.email}
            helperText={formik.errors.email}
            fullWidth
          />

          <TextField
            type={showPassword ? 'text' : 'password'}
            size="medium"
            className="password-input"
            label="Password"
            name="password"
            value={formik?.values?.password}
            onChange={formik?.handleChange}
            error={!!formik.errors.password}
            helperText={formik.errors.password}
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={onChagneShowPassword} edge="end">
                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Link className="go-password-reset" to={passwordResetUrl}>
            <Typography variant="body3" component="span" style={{ color: '#212121' }}>
              Reset password
            </Typography>
          </Link>
        </div>

        <div className="login-method-button-wrapper">
          <Button
            type="submit"
            size="large"
            cName={`submit-btn ${formik?.values?.email === '' || formik?.values?.password === '' ? 'disable' : ''}`}
            variant="contained"
            disabled={loading}
          >
            Log In With Email
          </Button>

          {!isComDomain && (
            <>
              <div className="divider-wrapper">
                <div className="divider" />
                <Typography variant="body2" component="span" style={{ color: '#666666' }}>
                  or
                </Typography>
                <div className="divider" />
              </div>

              <div className="social-login-button-wrapper">
                <GoogleLoginButton />
                <FacebookLoginButton />
              </div>
            </>
          )}
        </div>

        <div className="form-bottom-text-wrapper">
          <div className="sign-up-text-wrapper">
            <Typography variant="body2" component="p" style={{ color: '#212121' }}>
              Don’t have an account yet?
            </Typography>

            {/* TODO : remove after com complete */}
            {isComDomain ? (
              <Button cName="go-sign-up-btn" variant="text" onClick={() => setShowAlertModal(true)}>
                Sign up
              </Button>
            ) : (
              <Link to={accountSignupUrl}>
                <Button size="medium" cName="go-sign-up-btn" variant="text">
                  Sign Up
                </Button>
              </Link>
            )}
          </div>

          <Typography cName="tnc-text" variant="body2" component="p" style={{ color: '#212121' }}>
            By logging in, you agree to <Link to={tncUrl}>Maccaron’s T&Cs</Link>
          </Typography>
        </div>
      </form>

      {/* TODO : remove after com complete */}
      {isComDomain && showAlertModal && (
        <BasicModal
          title="Register Not Available"
          titleColor={'#212121'}
          content={`Sorry for the inconvenience caused.
          Service is not available currently.
          Thanks for your patience.`}
          contentColor={'#11141D99'}
          open={showAlertModal}
          onClose={handleAlertModalClose}
          closeButtonText="Got it"
          showCloseIcon={false}
        />
      )}
    </div>
  );
};

export default DesktopLoginPage;
